import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import Navbar from "../Navbar/Navbar.jsx";
import Banner from "../Banner/Banner.jsx";
import logo from "../../../assets/logo.png";
import rba from "../../../assets/logo_rba.png";

export default function Cabecalho(props) {
  const [scrolling, setScrolling] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolling(window.scrollY > 50);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <header>
      <div className={`cabecalho ${scrolling ? "scrolled" : ""}`}>
        <div className="cabecalho-container">
          <div className="logos">
            <Link to={`/${props.lang || "pt"}`}>
              <img src={logo} alt="Logo Grancaju" className="logo" />
              <img src={rba} alt="Logo Reval Brasil" className="logo" />
            </Link>
          </div>
          <Navbar {...props} />
        </div>
      </div>
      <Banner />
    </header>
  );
}
